const Style = {
  label: "text-sm lg:text-2xl text-white font-medium ml-2 mb-2",

  input:
    "px-[18px] py-2 rounded-full lg:text-2xl w-full text-black border border-slate-400",

  error: "text-[0.75em] lg:text-lg text-red-600 font-semilbold mt-2 ml-2",

  submitButton:
    "px-[18px] py-2 bg-[#CF2027] gap-4 rounded-full items-center justify-center flex hover:bg-[#CF202790] transition-colors cursor-pointer w-full lg:text-2xl text-white",

  cancelButton: `px-[18px] py-2 bg-[#FFFFFF] text-gray hover:text-white border border-slate-400 hover:border-red-500 rounded-full hover:bg-red-500 transition-colors w-full lg:text-2xl `,

  container: "flex flex-col md:flex-row justify-end gap-1 md:gap-3",

  button: `bg-[#CF2027] p-2 md:p-3 text-sm md:text-lg lg:text-xl text-white flex justify-center w-full md:w-auto md:px-6
  items-center gap-4 shadow-md rounded-full hover:bg-[#CF202790] transition-colors`,

  button2: `bg-[#CF2027] py-3 px-5 text-sm md:text-lg lg:text-xl text-white flex justify-center w-fit md:px-6
  items-center gap-4 shadow-md rounded-full hover:bg-opacity-90 transition-colors`,

  blueButton:
    "px-[18px] py-2 bg-[#0058DC] gap-4 rounded-full items-center justify-center flex cursor-pointer w-full lg:text-2xl text-white",

  iconButton: `bg-white p-[0.9rem] text-sm flex justify-center border-2
  items-center rounded-md hover:bg-[#d8d8d8] transition-colors`,

  header: "relative border-dotted border-slate-100 border-b items-center",

  title: "float:left m-0 text-lg font-semibold",

  link: "text-[0.75em] text-blue-500 text-end"
};

export default Style;
